import mapboxgl from 'mapbox-gl';
import React from 'react';

class KontaktMap extends React.Component {

    createMap() {
        const iconSize = 1
        const map = new mapboxgl.Map({
            center: [11.564750, 48.122210],
            container: 'map',
            style: 'mapbox://styles/mapbox/light-v9',
            trackResize: 'true',
            zoom: 16,
            pitch: 30,
            bearing: -30,
            detectRetina: 'true'
        })
       // map.scrollZoom.disable()


        var el = document.createElement('div');
        el.className = 'marker';
        el.style.backgroundImage = 'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIwMCIgaGVpZ2h0PSIxMjAwIiB2aWV3Qm94PSIwIDAgMTIwMCAxMjAwIj48Zz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZmZmZmZmIj48L3JlY3Q+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjAwIDYwMCkgc2NhbGUoMC42OSAwLjY5KSByb3RhdGUoMCkgdHJhbnNsYXRlKC02MDAgLTYwMCkiIHN0eWxlPSJmaWxsOiNmNDdmMjQ7Ij48c3ZnIGZpbGw9IiNmNDdmMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZlcnNpb249IjEuMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxMDAgMTAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNNTAsMjVjNi44OTYsMCwxMi41LDUuNjA0LDEyLjUsMTIuNVM1Ni44OTYsNTAsNTAsNTBzLTEyLjUtNS42MDQtMTIuNS0xMi41UzQzLjEwNCwyNSw1MCwyNXogTTUwLDAgIEMyOS4xNjcsMCwxMi41LDE2LjY2NywxMi41LDM3LjVTMjkuMTY3LDc1LDUwLDEwMGMyMC44MzMtMjUsMzcuNS00MS42NjcsMzcuNS02Mi41UzcwLjgzMywwLDUwLDB6Ij48L3BhdGg+PC9zdmc+PC9nPjwvZz48L3N2Zz4=);)'
// var marker = new mapboxgl.Marker()

        map.on('load', () => {
            
            new mapboxgl.Marker(el)
                .setLngLat([11.564750, 48.122210])
                .addTo(map);
                
                (map) => { map.resize() }    

        })
    }

    componentDidMount() {
        mapboxgl.accessToken = 'pk.eyJ1IjoiYnVyZWF1d2Vocm1hbm4iLCJhIjoiY2psMnMycDZ4MXRwZTNrbGJqOW5vMWZsbSJ9.Rxv80w8JfySMDLK3dUrsqg'
        this.createMap()
    }

    render() {
        return (
            
                <div id={'map'} style={{ width: '100%', height: '100%' }} />
          
        )
    }
}

export default KontaktMap


// WEBPACK FOOTER //
// ./src/components/kontakt-map.js